// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__2pMSW","inner":"style_inner__3HMHb","bottom":"style_bottom__2e-HB","copyright":"style_copyright__bBNwZ"};